export default function Dashboard() {
  return (
    <div className="h-full p-3" />
  );
}
